/* eslint-disable react/prop-types */
import React from 'react';

export const Task = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.017 10.816H12.707C12.293 10.816 11.957 10.48 11.957 10.066C11.957 9.652 12.293 9.316 12.707 9.316H17.017C17.431 9.316 17.767 9.652 17.767 10.066C17.767 10.48 17.431 10.816 17.017 10.816ZM17.017 16.055H12.707C12.293 16.055 11.957 15.719 11.957 15.305C11.957 14.891 12.293 14.555 12.707 14.555H17.017C17.431 14.555 17.767 14.891 17.767 15.305C17.767 15.719 17.431 16.055 17.017 16.055ZM10.424 9.108L8.821 10.712C8.68 10.852 8.489 10.931 8.29 10.931C8.091 10.931 7.9 10.852 7.76 10.711L6.936 9.887C6.644 9.594 6.644 9.119 6.937 8.826C7.229 8.534 7.705 8.533 7.998 8.827L8.291 9.12L9.363 8.048C9.656 7.755 10.131 7.755 10.424 8.048C10.717 8.341 10.717 8.816 10.424 9.108ZM10.424 14.35L8.821 15.953C8.674 16.1 8.482 16.173 8.29 16.173C8.099 16.173 7.907 16.1 7.76 15.953L6.937 15.13C6.644 14.838 6.644 14.363 6.937 14.07C7.23 13.777 7.704 13.777 7.997 14.07L8.29 14.362L9.363 13.29C9.656 12.997 10.131 12.997 10.424 13.29C10.717 13.583 10.717 14.057 10.424 14.35ZM16.217 2.5H7.783C4.623 2.5 2.5 4.721 2.5 8.026V15.974C2.5 19.279 4.623 21.5 7.783 21.5H16.216C19.376 21.5 21.5 19.279 21.5 15.974V8.026C21.5 4.721 19.377 2.5 16.217 2.5Z"
      fill="url(#paint0_linear_2052_560)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2052_560"
        x1="12"
        y1="2.5"
        x2="12"
        y2="21.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.color} />
        <stop offset="1" stopColor={props.color} />
      </linearGradient>
    </defs>
  </svg>
);
